import React, { createContext, useState, useMemo, useCallback } from 'react';

export const AIPromptContext = createContext({
  aiData: null,
  aiPrompt: false,
  aiPayload: null,
  defineAIData: () => {},
  openAIPrompt: () => {},
  closeAIPrompt: () => {},
  defineAIPayload: () => {},
});

export function AIPromptProvider({ children }) {
  const [aiData, setAIData] = useState(null);
  const [aiPrompt, setAIPrompt] = useState(false);
  const [aiPayload, setAIPayload] = useState(null);

  const openAIPrompt = useCallback(() => setAIPrompt(true), []);
  const closeAIPrompt = useCallback(() => setAIPrompt(false), []);
  const defineAIData = useCallback((value) => setAIData(value), []);
  const defineAIPayload = useCallback((value) => setAIPayload(value), []);

  const value = useMemo(
    () => ({
      aiData,
      aiPrompt,
      aiPayload,
      defineAIData,
      openAIPrompt,
      closeAIPrompt,
      defineAIPayload,
    }),
    [aiPrompt, aiData, aiPayload, openAIPrompt, closeAIPrompt, defineAIData, defineAIPayload] 
  );

  return (
    <AIPromptContext.Provider value={value}>
      {children}
    </AIPromptContext.Provider>
  );
}